<template>
  <div class="slider u-pad-l-1of12 u-pad-y-xl u-pad-y-md--sm u-overflow-hidden">
    <div class="u-row">
      <div class="t-h3 u-blue u-w8of10">
        {{ data.titre }}
      </div>
      <div class="u-w1of10" v-if="!$device.isMobile && data.image.length > 2">
        <div class="u-row">
          <div class="u-w3of10 u-marg-r-1of10">
            <img class="u-cursor-pointer u-block u-full-width" src="/images/slider--left.png" alt="left icon" @click="onPrev"/>
          </div>
          <div class="u-w3of10">
            <img class="u-cursor-pointer u-block u-full-width" src="/images/slider--right.png" alt="right icon" @click="onNext"/>
          </div>
        </div>
      </div>
    </div>
    <core-drag ref="drag">
      <div class="slider__wrapper u-flex u-inline-block u-nowrap js-drag u-select-none u-top u-marg-t-md">
        <div
          v-for="(image, index) in data.image"
          :key="index"
          class="slider__item u-inline-block js-drag-item u-pad-x-md"
          draggable="false"
        >
          <div class="u-box-4by3">
            <app-image
              :width="800"
              :height="600"
              alt="Project picture"
              :id="image.id"
              :src="image.url"
              class="u-wrapper-panel u-fit-cover u-radius u-overflow-hidden"
              draggable="false"
            />
          </div>
          <p v-if="data.legends && data.legends[index]" class="t-text u-marg-t-sm u-pad-t-xs">{{data.legends[index].legend}}</p>
        </div>
      </div>
    </core-drag>
  </div>
</template>

<script>
import CoreDrag from '@/components/common/CoreDrag'

export default {
  components: {
    CoreDrag
  },
  props: {
    data: {
      type: Object,
      required: true
    },
  },
  methods: {
    onPrev () {
      this.$refs.drag.onPrev()
    },
    onNext () {
      this.$refs.drag.onNext()
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/mixins/mq'

.slider  
  &__wrapper
    margin-left -1*$spacings.md

  &__item
    max-width 700px
    width 40vw
    vertical-align top

    +mq($until: 'tablet')
      width 80vw

</style>